export default __webpack_public_path__ + "static/media/india.5aa07a52.svg";